import React, {Component} from 'react';
import { makeStyles } from '@material-ui/core/styles';
//import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

export default class SimpleSelectDocType extends Component {

  	constructor(props){
        super(props);
		this.state={
            defaultValue:this.props.defaultValue.state?this.props.defaultValue.state.defaultValue:this.props.defaultValue,
        }
	}

  	handleChange = event => {
        this.setState({value:event.target.value});
        if(event.target.value === 'PP')
           this.props.pas(true,event.target.value,this.props.i);
        else
           this.props.pas(false,event.target.value,this.props.i);
	};

  	render(){
		const classes = makeStyles(theme => ({ formControl: { "& .MuiPaper-root": { maxHeight: '340px' } } }));
		const { id, labelId, label, labelText, optionsSelect, /* classNameCustom,defaultValue,  */name/* , i */ } = this.props;

	    return (
        <FormControl variant="outlined" fullWidth className={`InputForm ${classes.formControl}`} >
            <InputLabel id={`label-${id}`}>{label}</InputLabel>
            <Select
              //  className={`InputForm ${classNameCustom}`}
                labelId={labelId}
                id={id}
                name={name}
                onChange={this.handleChange}
                label={labelText}
                defaultValue={this.state.defaultValue}
            >    
              
            {optionsSelect.map((option, i) => (
                    <MenuItem key={i} value={option.code}>{option.description}</MenuItem>
            ))}
            </Select>
        </FormControl>
	);
  }
}